import script from "./ActivityDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityDetail.vue?vue&type=style&index=0&id=00ad10a2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00ad10a2"]])

export default __exports__